import {
    type UpdateGenericInfoResponseType,
    type UpdateGenericInfoRequestType
} from "./type";
import {
    request
} from "../request";

const updateGenericInfo = async (params: UpdateGenericInfoRequestType): Promise<UpdateGenericInfoResponseType> => {
    return await request<UpdateGenericInfoResponseType>("/content/updateGenericInfo", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default updateGenericInfo;
